import { Height } from "../../../../components/Icons/SettingNotification/Height"
import { Information } from "../../../../components/Icons/SettingNotification/Information"
import { Low } from "../../../../components/Icons/SettingNotification/Low"
import { Medium } from "../../../../components/Icons/SettingNotification/Medium"
import { Serious } from "../../../../components/Icons/SettingNotification/Serious"
import i18n from "../../../../i18n";
const { t } = i18n;

export const listIconLevel = [
    {
        CODE: "HIGH",
        ICON: <Height />
    },
    {
        CODE: "INFOR",
        ICON: <Information />
    },
    {
        CODE: "LOW",
        ICON: <Low />
    },
    {
        CODE: "MEDIUM",
        ICON: <Medium />
    },
    {
        CODE: "SERIOUS",
        ICON: <Serious />
    }
]

export const timeChip = [
    {
        label: t('setupNotification.Real_time'),
        value: "0",
    },
    {
        label: "2 " + t('setupNotification.minute'),
        value: "2",
    },
    {
        label: "5 " + t('setupNotification.minute'),
        value: "5",
    },
    {
        label: "10 " + t('setupNotification.minute'),
        value: "10",
    },
]

export const columns = [
    {
        title: t('setupNotification.Notification_name'),
        dataIndex: 'detail',
        key: 'detail',
        width: "28%"
    },
    {
        title: '',
        dataIndex: 'type_code',
        key: 'type_code',
        type: 'input',
        width: 0,
        props: {
            style: {
                display: 'none'
            },
            disable: true
        }
    },
    {
        title: 'Telegram',
        dataIndex: 'telegram',
        key: 'telegram',
        type: 'switch',
        props: {
            size: "default"
        },
        width: "5%"
    },
    {
        title: 'App',
        dataIndex: 'app',
        key: 'app',
        type: 'switch',
        props: {
            size: "default"
        },
        width: "5%"
    },
    {
        title: t('setupNotification.Warning_color'),
        dataIndex: 'event_color',
        key: 'event_color',
        type: 'color-picker',
        props: {
            showText: true
        },
        width: "15%"
    },
    {
        title: t('setupNotification.Warning_level'),
        dataIndex: 'notification_level_code',
        key: 'notification_level_code',
        type: "select",
        options: listIconLevel,
        width: "25%"
    },
    {
        title: t('setupNotification.Notification_time'),
        dataIndex: 'alert_time',
        key: 'alert_time',
        type: "select",
        options: timeChip,
        width: "20%"
    },
]


